import { Box, Container, Typography } from '@mui/material';
import React from 'react';
import Footer from '../Shared/Footer/Footer';
import Header from '../Shared/Header/Header';

const Blogs = () => {
    return (
        <>
            <Header></Header>
            <Container>
                <Box style={{ minHeight: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Typography variant="h1" component="div" gutterBottom>
                        Comming Soon...
                    </Typography>
                </Box>
            </Container>
            <Footer></Footer>
        </>
    );
};

export default Blogs;